import { useState } from "react"

import { useStartCandidateCall } from "../calling/useStartCandidateCall"
import SendEmailCampaignDialog from "../candidate-details/SendEmailCampaignDialog"
import SendEmailDirectlyDialog from "../candidate-details/SendEmailDirectlyDialog"
import SendEmailMenu, {
  SEND_REQUEST_TYPE,
} from "../candidate-details/SendEmailMenu"
import SendSMSCampaignDialog, {
  useManageSendSMSCampaignDialog,
} from "../candidate-details/SendSMSCampaignDialog"
import ConfirmConnectEmailDialog, {
  MAIL_PROVIDER_AUTH_STATUS,
  useConnectEmailDialogRequirements,
} from "./ConfirmConnectEmailDialog"
import {
  SendingEmailTrialFinishedDialogData,
  useTrialFinishedDialogUtils,
} from "./TrialFinishedRoadblockDialog"

export function useCandidateActions(openSnackbar) {
  const [actionCandidate, setActionCandidate] = useState(null)
  const [sendEmailCampaignDialogOpen, setSendEmailCampaignDialogOpen] =
    useState(false)
  const [sendEmailDirectlyDialogOpen, setSendEmailDirectlyDialogOpen] =
    useState(false)
  const [emailMenuRef, setEmailMenuRef] = useState(null)

  const {
    sendSMSCampaignDialogOpen,
    setSendSMSCampaignDialogOpen,
    handleSendSMSButtonClicked: handleSMSDialogButtonClicked,
  } = useManageSendSMSCampaignDialog()

  const { requestCall } = useStartCandidateCall(openSnackbar)
  const { runOnlyIfSubscribed } = useTrialFinishedDialogUtils()

  function rowProviderAuthCallback(status, message) {
    switch (status) {
      case MAIL_PROVIDER_AUTH_STATUS.msIDPopupWindowError:
        openSnackbar(message)
        break
      default:
        break
    }
  }

  const {
    confirmConnectEmailDialogOpen,
    openConfirmConnectEmailDialog,
    handleConfirmConnectGmailDialogClosed,
    emailAuthorized,
  } = useConnectEmailDialogRequirements(rowProviderAuthCallback)

  function handleEmailButtonClicked(e, candidate) {
    e.stopPropagation()
    setActionCandidate(candidate)
    runOnlyIfSubscribed(
      () => setEmailMenuRef(e.currentTarget),
      SendingEmailTrialFinishedDialogData
    )
  }

  function handleEmailMenuClosed(result) {
    if (emailAuthorized) {
      switch (result) {
        case SEND_REQUEST_TYPE.campaign:
          setSendEmailCampaignDialogOpen(true)
          break
        case SEND_REQUEST_TYPE.direct:
          setSendEmailDirectlyDialogOpen(true)
          break
        default:
      }
    } else if (result) {
      openConfirmConnectEmailDialog()
    }
    setEmailMenuRef(null)
  }

  function handleSMSButtonClicked(e, candidate) {
    e.stopPropagation()
    setActionCandidate(candidate)
    handleSMSDialogButtonClicked()
  }

  function handleCallButtonClicked(e, candidate) {
    e.preventDefault()
    e.stopPropagation()
    setActionCandidate(candidate)
    requestCall(candidate)
  }

  return {
    actionCandidate,
    sendEmailCampaignDialogOpen,
    setSendEmailCampaignDialogOpen,
    sendEmailDirectlyDialogOpen,
    setSendEmailDirectlyDialogOpen,
    emailMenuRef,
    sendSMSCampaignDialogOpen,
    setSendSMSCampaignDialogOpen,
    confirmConnectEmailDialogOpen,
    handleEmailButtonClicked,
    handleSMSButtonClicked,
    handleCallButtonClicked,
    handleEmailMenuClosed,
    handleSMSDialogButtonClicked,
    handleConfirmConnectGmailDialogClosed,
  }
}

export function CandidateActionDialogs({ actionsState }) {
  const {
    actionCandidate,
    sendEmailCampaignDialogOpen,
    setSendEmailCampaignDialogOpen,
    sendEmailDirectlyDialogOpen,
    setSendEmailDirectlyDialogOpen,
    emailMenuRef,
    sendSMSCampaignDialogOpen,
    setSendSMSCampaignDialogOpen,
    confirmConnectEmailDialogOpen,
    handleEmailMenuClosed,
    handleConfirmConnectGmailDialogClosed,
  } = actionsState

  return (
    <>
      <SendEmailCampaignDialog
        open={sendEmailCampaignDialogOpen}
        onClose={() => setSendEmailCampaignDialogOpen(false)}
        candidate={actionCandidate || {}}
      />
      <SendEmailDirectlyDialog
        open={sendEmailDirectlyDialogOpen}
        onClose={() => setSendEmailDirectlyDialogOpen(false)}
        candidate={actionCandidate || {}}
      />
      <SendSMSCampaignDialog
        open={sendSMSCampaignDialogOpen}
        onClose={() => setSendSMSCampaignDialogOpen(false)}
        candidate={actionCandidate || {}}
      />
      <ConfirmConnectEmailDialog
        open={confirmConnectEmailDialogOpen}
        onClose={handleConfirmConnectGmailDialogClosed}
      />
      <SendEmailMenu
        anchorElem={emailMenuRef}
        onClose={handleEmailMenuClosed}
      />
    </>
  )
}
